export const REMOTE_URL = "";
export const GET_DEPT_URL = "/api/v1/regions/get_countries";
export const ADD_DEPT_URL = "/api/v1/regions/create";
export const UPD_DEPT_URL = "/api/v1/regions/update";
